import { defineMessages } from '@jutro/locale';

export default defineMessages({
    noRenewalNotes: {
        id: 'gateway.views.renewal.renewal-notes.There are no notes associated with this Renewal.',
        defaultMessage: 'There are no notes associated with this Renewal.'
    }
});
